import React, { PureComponent } from 'react'
import { Col, Form, Icon,Layout, Select,Input,Upload,Button,message} from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import PrevImg from '_src/components/PrevImg/PrevImg'
import { getData,getDetail } from '../../api/api'
import { getRandomN} from '../../utils/tool'
// 替换为七牛上传
import { UploadIMGToQiniu } from '_src/utils/qiniu'
import instance from '../../api/bankRequest'
const { Content  } = Layout
const { Option } = Select
const uploadButton = (
    <div style={{width:250,height:120}}>
      <Icon type="plus" />
      <div className="ant-upload-text">上传</div>
    </div>
)

@Form.create({ name: '' })
@observer
class Home extends PureComponent {
	
	@observable bussLicense = [] //营业执照
	@observable legalFrontPic = [] //法人身份证正面
	@observable legalBackPic = [] //法人身份证反面
    @observable platRoleID = '100' //平台角色
    @observable registrant = '1' //注册身份
    @observable accType = '2' //账户类型
    @observable bussLicenseID = '' //营业执照
    @observable legalFrontPicID = '' //身份证正面照
    @observable legalBackPicID = '' //身份证反面照
    @observable dataInfo = '' //

    componentDidMount(){
       
    }

	handlePreview = (file) => this.PrevImg.show(file.thumbUrl || file.url)
	// 选择图片回调
    handleChange = ({ fileList },key) => {
        this[key] = fileList
        let img = []
        let _this = this
        img[0] = new Promise((resolve,reject) =>{
            UploadIMGToQiniu(fileList[0]).then(res =>{
                resolve(res)
            }).catch(function (err) {
                message.error('图片上传失败！', 1.5)
                reject(err)
                return false
              })
        })
        Promise.all(img).then(data =>{
            const param = {
                trxCode:'200014',
                fileUrl:data[0],
                fileType:'01',
                operType:'01'
            }
            getDetail(param).then(res =>{  
                if(res.data.rstCode === '0'){
                    if(key === 'bussLicense'){
                        this.bussLicenseID = res.data.fileId
                    }else if(key === 'legalFrontPic'){
                        this.legalFrontPicID = res.data.fileId
                    }else{
                        this.legalBackPicID = res.data.fileId
                    }
                }else{
                    message.error('请求失败',1.5)
                }
                // upData(URLencode(res.data)).then(res =>{
                //     getDedata(res).then(res =>{
                //         if(res.data.rstCode === '0'){
                //             if(key === 'bussLicense'){
                //                 this.bussLicenseID = res.data.fileId
                //             }else if(key === 'legalFrontPic'){
                //                 this.legalFrontPicID = res.data.fileId
                //             }else{
                //                 this.legalBackPicID = res.data.fileId
                //             }
                //         }else{
                //             message.error('请求失败',1.5)
                //         }
                //     })
                // })
            })
        })
    }
	//表单提交
	onSubmit = (e) =>{
        e.preventDefault()
        const { bussLicenseID,legalFrontPicID,legalBackPicID } = this
        let _this = this
        this.props.form.validateFields((err, values)=>{
            console.log(values)
            if(!err){
                const param = {
                    trxCode:'100004',
                    // platCusNO:values.platCusNO,
                    platCusNO:getRandomN(),
                    platRoleID:values.platRoleID,
                    busFullNm:values.busFullNm,
                    registrant:values.registrant,
                    legalPerNm:values.legalPerNm,
                    legalPerIdNo:values.legalPerIdNo,
                    agent:values.agent,
                    agentIdNo:values.agentIdNo,
                    agentMbl:values.agentMbl,
                    agentIdEdt:values.agentIdEdt,
                    accType:values.accType,
                    pageRetUrl:'http://teruo-home.gdhttech.com/pay/openAccount',
                    bgRetUrl:'http://teruo-home.gdhttech.com/pay/openAccount',
                    bussLicenseID,
                    legalFrontPic:legalFrontPicID,
                    legalBackPic:legalBackPicID
                }
                console.log(param)
                getData(param).then(res =>{
                _this.dataInfo = res.data.split('&')
                document.forms[1].submit();
                })
            }
        })
	}
    dataSubmit = () =>{
        console.log(111)
    }

	render() {
        const { dataInfo } = this
		const { getFieldDecorator } = this.props.form
		return (
			<div className="page_content">
				<PrevImg ref={el => this.PrevImg = el} />
				<div className='title'>
					<span>企业用户开电子登记簿</span>
					<Button type='primary' className='back' onClick={() => window.history.back(-1)}>返回</Button>
				</div>
				<Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 6}} wrapperCol = {{span: 16}}>
					<Form.Item label="企业角色">
						{getFieldDecorator('platRoleID', {initialValue: this.platRoleID, rules: [{ required: true, message: '企业角色不能为空'}] })
						(<Select
							onChange={(v)=>this.platRoleID=v}
							placeholder='请选择企业角色'
							>
							<Option value={'002'} key={'002'}>个体工商户</Option>
							<Option value={'100'} key={'100'}>企业店铺</Option>
							<Option value={'102'} key={'102'}>企业分公司</Option>
							<Option value={'150'} key={'150'}>企业分账簿</Option>
						</Select>) }
					</Form.Item>
                    {/* <Form.Item label="交易平台用户编号">
                        {getFieldDecorator('platCusNO', {initialValue: this.platCusNO, rules: [{ required: true, message: '交易平台用户编号不能为空'}] })(
                        <Input placeholder="交易平台用户编号" />)}
                    </Form.Item> */}
					<Form.Item label="公司名称">
                        {getFieldDecorator('busFullNm', {initialValue: this.busFullNm, rules: [{ required: true, message: '公司名称不能为空'}] })(
                        <Input placeholder="请输入公司名称" />)}
                    </Form.Item>
					<Form.Item label="注册人身份">
						{getFieldDecorator('registrant', {initialValue: this.registrant, rules: [{ required: true, message: '注册人身份不能为空'}] })
						(<Select
							onChange={(v) =>{this.registrant=v}}
							placeholder='请选择注册人身份'
							>
							<Option value={'1'} key={'1'}>法定代表人</Option>
							<Option value={'2'} key={'2'}>被授权人</Option>
						</Select>) }
					</Form.Item>
					<Form.Item label="法人真实姓名">
                        {getFieldDecorator('legalPerNm', {initialValue: this.legalPerNm, rules: [{ required: true, message: '法人真实姓名不能为空'}] })(
                        <Input placeholder="请输入法人真实姓名" />)}
                    </Form.Item>
					<Form.Item label="法人身份证">
                        {getFieldDecorator('legalPerIdNo', {initialValue: this.legalPerIdNo, rules: [{ required: true,pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '法人身份证号格式不正确'}] })(
                        <Input placeholder="请输入法人身份证" />)}
                    </Form.Item>
					<Form.Item label="被授权人姓名">
                        {getFieldDecorator('agent', {initialValue: this.agent, rules: [{ required: true, message: '被授权人姓名不能为空'}] })(
                        <Input placeholder="请输入被授权人姓名" />)}
                    </Form.Item>
					<Form.Item label="被授权人身份证">
                        {getFieldDecorator('agentIdNo', {initialValue: this.agentIdNo, rules: [{ required: true,pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '被授权人身份证号格式不正确'}] })(
                        <Input placeholder="请输入被授权人身份证" />)}
                    </Form.Item>
                    <Form.Item label="身份证有效期">
                        {getFieldDecorator('agentIdEdt', {initialValue: this.agentIdEdt, rules: [{ required: true, message: '请输入身份证有效期'}] })(
                        <Input placeholder="请输入身份证有效期(如20220823)" />)}
                    </Form.Item>
					<Form.Item label="被授权人手机号">
                        {getFieldDecorator('agentMbl', {initialValue: this.agentMbl, rules: [{ required: true,pattern:/^1[3456789]\d{9}$/, message: '请输入正确的手机号'}] })(
                        <Input placeholder="请输入被授权人手机号" />)}
                    </Form.Item>
					<Form.Item label="账户类型">
						{getFieldDecorator('accType', {initialValue: this.accType, rules: [{ required: true, message: '账户类型不能为空'}] })
						(<Select
							onChange={(v)=>this.accType=v}
							placeholder='请选择账户类型'
							>
							<Option value={'2'} key={'2'}>对公</Option>
							<Option value={'1'} key={'1'}>对私</Option>
						</Select>)}
					</Form.Item>
					<Form.Item label="营业执照" className='flex'>
                        {getFieldDecorator('bussLicense', {
                            rules: [{
                            required: true,
                            message: '请上营业执照图片',
                            }],
                            initialValue: this.bussLicense?this.bussLicense:'',
                        })(
                            <Upload
                            className='upload-img flex'
                            action=""
                            multiple
                            listType="picture-card"
                            fileList={this.bussLicense}
                            onPreview={this.handlePreview}
                            onChange={(v) => this.handleChange(v,'bussLicense')}
                            beforeUpload={() => { return false }}
                            >
                             { this.bussLicense.length>=1 ?null:uploadButton}
                            </Upload>
                        )}
                    </Form.Item>
					<Form.Item label="法人身份证正面" className='flex'>
                        {getFieldDecorator('legalFrontPic', {
                            rules: [{
                            required: true,
                            message: '请上法人身份证正面',
                            }],
                            initialValue: this.legalFrontPic?this.legalFrontPic:'',
                        })(
                            <Upload
                            className='upload-img flex'
                            action=""
                            multiple
                            listType="picture-card"
                            fileList={this.legalFrontPic}
                            onPreview={this.handlePreview}
                            onChange={(v) => this.handleChange(v,'legalFrontPic')}
                            beforeUpload={() => { return false }}
                            >
                            { this.legalFrontPic.length>=1 ?null:uploadButton}
                            </Upload>
                        )}
                    </Form.Item>
					<Form.Item label="法人身份证反面" className='flex'>
                        {getFieldDecorator('legalBackPic', {
                            rules: [{
                            required: true,
                            message: '请上法人身份证反面',
                            }],
                            initialValue: this.legalBackPic?this.legalBackPic:'',
                        })(
                            <Upload
                            className='upload-img flex'
                            action=""
                            multiple
                            listType="picture-card"
                            fileList={this.legalBackPic}
                            onPreview={this.handlePreview}
                            onChange={(v) => this.handleChange(v,'legalBackPic')}
                            beforeUpload={() => { return false }}
                            >
                             { this.legalBackPic.length>=1 ?null:uploadButton}
                            </Upload>
                        )}
                    </Form.Item>
					<Form.Item>
						<Button type="primary" htmlType="submit"  style={{ width: 200,borderRadius:20,height:40,marginLeft:200}}>提交</Button>
					</Form.Item>
				</Form>
                <Form method='post' action={instance.baseURL+'/bhdep/payTransactionNew'} style={{display:'none'}} >
                    <Input type='text' name='INFO' value={dataInfo? dataInfo[0].substring(5):''}/>
                    <Input type='text' name='BODY' value={dataInfo? dataInfo[1].substring(5):''}/>
                    <Input type='text' name='SIGN' value={dataInfo? dataInfo[2].substring(5):''}/>
                    <Input type='text' name='CONTENTTYPE' value='json'/>
                    <Input type='submit' value='提交' />
                </Form>
			</div>
		)
	}
}
export default Home
